import { getApiClient } from "@/services/API";

const whiteLabelBrandingService = {
  /**
   * Gets white label branding by entity ID
   * @param {string} entityId - The entity ID to search for
   * @returns {Object|undefined} - Branding data or undefined if not found
   * Intentionally skips the error bus since if there is no branding this will 404, error will still be thrown and can be caught
   * and have relevant toasting/modal notification as needed on a case by case basis.
   */
  async getByEntityId(entityId) {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.get(`/white-label-branding/entity/${entityId}`, {
        skipErrorBus: true,
      });
      return response.data.data;
    } catch (error) {
      if (error.response?.status !== 404) {
        throw error;
      }
    }
  },

  async upsert(payload) {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.put(`/white-label-branding/upsert`, payload);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  },
};

export default whiteLabelBrandingService;
